import { Image, Notes, Head, themes } from "mdx-deck";
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { vsDark as classTheme, nightOwl as hooksTheme, oceanicNext as oceanicTheme } from "@code-surfer/themes";
import Layout, { Splits } from "../../../../../../components/Layout";
import CodeBlock from "../../../../../../components/CodeBlock";
import AppLoader from "../../../../../../src/app-loader";
import * as React from 'react';
export default {
  Image: Image,
  Notes: Notes,
  Head: Head,
  themes: themes,
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  classTheme: classTheme,
  hooksTheme: hooksTheme,
  oceanicTheme: oceanicTheme,
  Layout: Layout,
  Splits: Splits,
  CodeBlock: CodeBlock,
  AppLoader: AppLoader,
  React: React
};